module.exports = "<p>\r\n  finance works!\r\n</p>\r\n"